
import React from 'react';
import { Check } from 'lucide-react';

const CustomSolutionsFuture = () => {
  return (
    <section className="py-20 bg-[#1A1F2C] text-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left column */}
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">
              The Future of Legal Work Is Being Automated — 
              <span className="text-gradient block mt-2">Will Your Firm Lead or Lag?</span>
            </h2>
            
            <p className="text-lg text-gray-300 leading-relaxed">
              Large firms are automating at scale — but the future belongs to firms that act 
              strategically, not just those with deep pockets. DocketLabs delivers tailored, 
              affordable AI solutions that help small and mid-sized firms automate smarter, 
              compete harder, and lead with confidence.
            </p>
          </div>
          
          {/* Right column */}
          <div className="bg-[#222538] rounded-xl p-6 border border-gray-700/30 shadow-xl">
            <ul className="space-y-5">
              {[
                'Work faster with less overhead',
                'Improve output quality',
                'Unlock new client opportunities'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="mr-4 mt-1 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full p-1">
                    <Check className="h-5 w-5 text-white" />
                  </div>
                  <p className="text-xl font-medium text-gray-100">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomSolutionsFuture;
